import { useCallback } from 'react';

import { useQuery } from '@tanstack/react-query';
import tinycolor from 'tinycolor2';

import { isDefined, sort } from '@hsp/utilities';

import { globalQueryKeys } from 'hooks/queries/query-keys';
import { clientService } from 'services';
import { IClient } from 'types/api/client';
import { IDataContainer, IResult } from 'types/api/common';

export const useFetchClients = () => {
  return useQuery({
    queryFn: async () => {
      return await clientService.getClients();
    },
    queryKey: globalQueryKeys.clients,
    select: useCallback((data: IResult<IDataContainer<IClient[]>> | undefined) => {
      const clients = data?.dataContainer?.data ?? [];

      sort(clients, { direction: 'asc', field: 'name' });

      return clients
        .filter(({ isInactive }) => isDefined(isInactive) && !isInactive)
        .map((client) => {
          const backgroundColor = tinycolor.random().lighten(10).setAlpha(0.5);
          const color = backgroundColor.isDark()
            ? backgroundColor.clone().lighten(80)
            : backgroundColor.clone().darken(80);
          const modified: IClient = {
            ...client,
            backgroundColor: backgroundColor.toHslString(),
            color: color.setAlpha(1).toHslString(),
          };

          return modified;
        });
    }, []),
  });
};
